module.exports = __webpack_public_path__ + "img/appIcon-menu--Reports.1b6aa2c2.svg";